import type { UserSearchProps } from './types';

const inputClass =
  'bg-[#0d1117] border border-[#30363d] text-[#c9d1d9] px-2.5 py-2 rounded-md text-sm font-mono w-full focus:outline-none focus:border-[#58a6ff]';

export const UserSearch = ({
  users,
  selectedUserId,
  searchQuery,
  loading,
  onSearchChange,
  onUserSelect,
}: UserSearchProps) => {
  return (
    <div className="bg-[#161b22] border border-[#30363d] rounded-lg p-4 mb-4">
      <h2 className="text-sm text-[#8b949e] uppercase tracking-wide mb-3">
        Search Users
      </h2>

      <input
        type="text"
        className={inputClass}
        value={searchQuery}
        onChange={(event) => onSearchChange(event.target.value)}
        placeholder="Search by name or email..."
      />

      {loading && (
        <p className="text-[12px] text-[#8b949e] mt-2">Searching...</p>
      )}

      {users.length > 0 && (
        <div className="mt-3 max-h-[240px] overflow-y-scroll">
          <table className="w-full text-[12px]">
            <thead>
              <tr className="text-[#8b949e] border-b border-[#30363d]">
                <th className="text-left py-1.5 px-2">Name</th>
                <th className="text-left py-1.5 px-2">Email</th>
                <th className="text-left py-1.5 px-2">Organization</th>
              </tr>
            </thead>
            <tbody>
              {users.map((user) => {
                const isSelected = user.id === selectedUserId;
                const fullName =
                  [user.firstName, user.lastName].filter(Boolean).join(' ') ||
                  '—';

                return (
                  <tr
                    key={user.id}
                    className={`cursor-pointer border-b border-[#21262d] transition-colors ${
                      isSelected
                        ? 'bg-[#1f6feb33] text-[#58a6ff]'
                        : 'hover:bg-[#21262d]'
                    }`}
                    onClick={() => onUserSelect(user.id)}
                  >
                    <td className="py-1.5 px-2">{fullName}</td>
                    <td className="py-1.5 px-2">{user.email}</td>
                    <td className="py-1.5 px-2">
                      {user.organizationName || '—'}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}

      {!loading && searchQuery && users.length === 0 && (
        <p className="text-[12px] text-[#8b949e] mt-2">No users found.</p>
      )}
    </div>
  );
};
